import { GlobalAxios } from "../axios/axios-config";
import {
  IDashboardGenerate,
  IDashboardGenerateConfig,
  IDashboardGenerateExecution,
} from "../models/dashboard-generate-execution";
import { ISearchReturn } from "../models/requests";
import MainApi from "./mainApi.service";

const BASE_URL = process.env.REACT_APP_MAIN;

const EXECUTION_ROUTE = BASE_URL + "/api/v1/DashboardGenerateExecution";
const GENERATE_ROUTE = BASE_URL + "/api/v1/DashboardGenerate";
const CONFIG_ROUTE = BASE_URL + "/api/v1/DashboardGenerateConfig";

export const dashboardGenerateExecutionService =
  new MainApi<IDashboardGenerateExecution>(EXECUTION_ROUTE);

export const dashboardGenerateService = new MainApi<IDashboardGenerate>(
  GENERATE_ROUTE,
);

export const getDashboardGenerateExecutions = (params: {
  DashboardPanelId: string;
  PageNumber: number;
  PageSize: number;
}) => {
  return GlobalAxios.get<ISearchReturn<IDashboardGenerateExecution>>(
    EXECUTION_ROUTE,
    { params },
  );
};

export const getDashboardGenerateExecutionPanels = () => {
  return GlobalAxios.get<{ id: string; name: string }[]>(
    EXECUTION_ROUTE + "/Panels",
  );
};

export const getDashboardGenerateExecutionById = (id: string) => {
  return GlobalAxios.get<IDashboardGenerateExecution>(
    EXECUTION_ROUTE + "/" + id,
  );
};

export const getDashboardPanelHasRunningExecution = (
  dashboardPanelId: string,
) => {
  return GlobalAxios.get<{ hasRunning: boolean }>(
    EXECUTION_ROUTE + "/HasRunning",
    {
      params: { dashboardPanelId },
    },
  );
};

export const reprocessDashboardGenerateExecution = ({
  id,
  dashboardGenerateId,
}: {
  id: string;
  dashboardGenerateId?: string;
}) => {
  return GlobalAxios.post<{ reprocessedGenerates: number }>(
    EXECUTION_ROUTE + "/" + id + "/Reprocess",
    { id, dashboardGenerateId },
  );
};

export const getDashboardGenerateConfig = () => {
  return GlobalAxios.get<IDashboardGenerateConfig>(CONFIG_ROUTE);
};

export const updateDashboardGenerateConfig = ({
  item,
  id,
}: {
  item: IDashboardGenerateConfig;
  id: string;
}) => {
  return GlobalAxios.put(CONFIG_ROUTE + "/" + id, item);
};
